import { useEffect, useState } from "react";
import { LOGO_URL } from "../data/content";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#gourmandises", label: "Gourmandises" },
  { href: "#zone-livraison", label: "Points de retrait" },
  { href: "#galerie", label: "Galerie" },
  { href: "/carte-fidelite", label: "Fidélité" },
  { href: "#contact", label: "Contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/75 backdrop-blur-xl shadow-[0_4px_24px_rgba(229,91,91,0.08)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-3 flex items-center justify-between">
        <a href="#hero" data-testid="header-logo-link" className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Amyu" className="h-12 md:h-14 w-auto drop-shadow-sm" />
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace(/[#/]/g, "")}`}
              className="text-sm font-medium text-amyu-ink hover:text-coral transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="/commander" data-testid="nav-order-cta" className="btn-coral text-sm">
            Commander
          </a>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 rounded-full bg-white/70 backdrop-blur"
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-amyu px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.href.replace(/[#/]/g, "")}`}
              className="py-2 text-amyu-ink"
            >
              {l.label}
            </a>
          ))}
          <a href="#commander" onClick={() => setOpen(false)} data-testid="mobile-nav-order" className="btn-coral text-center">
            Commander
          </a>
        </div>
      )}
    </header>
  );
};
